import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import FormTownHall from 'system/components/town-halls/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonTownHallCrumbs } from '../constants';
import { toast } from 'react-toastify';

const TownHallNewPage = (): React.ReactElement => {
  const { post: insertTownHall } = useHttpFetch(`${__TOPONYMY_API_URL__}/municipi`);
  const navigate = useNavigate();
  const onSubmit = useCallback(
    (formValues) => {
      insertTownHall({
        descrizioneBreve: formValues.shortDescription,
        descrizione: formValues.description,
        numeroCivico: formValues.streetNumber,
        areaCircolazione: formValues.address?.code,
        esponenteCivico: formValues.civicRepresentative,
        key: {
          codice: formValues.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/municipi');
      });
    },
    [insertTownHall, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonTownHallCrumbs, { name: 'Nuovo Municipio/Zona' }]} />
      <FormTownHall
        title="Nuovo Municipio/Zona"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/municipi');
        }}
      />
    </Fragment>
  );
};

TownHallNewPage.displayName = 'Town Hall new page component';

export default TownHallNewPage;
